import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AsbestosisService {

  constructor(
    public apiService: ApiService
  ) { }

  public getAntigenMarkerValues(requestParam: {}): Observable<any> {
    return this.apiService.getService('asbestos/antigen-marker-value', {});
  }
   
  public postSaveAntigenMarker(requestParam: {}): Observable<any> {
    return this.apiService.postService('asbestos/save/antigen-marker',requestParam);
  }

  public getAntigenMarkers(requestParam: {}): Observable<any> {
   return this.apiService.postService('asbestos/getAntigenMarkers', requestParam);
 }

 public deleteImmunoProfile(requestParam: {}): Observable<any> {
  return this.apiService.postService('asbestos/immunohistology-profile/delete',requestParam);
}
}
